import { Middleware } from '@reduxjs/toolkit';
import isBrowser from '../../helpers/isBrowser';
import {
  completePaymentFlow,
  initialPaymentFlow,
  persistPaymentFlow,
  startPaymentFlow,
} from './commonPaymentActions';
import { actions } from './paymentReducer';
import { getActiveDonation, getActiveSubscription, getAffiliate } from './paymentSelectors';

const persistMiddleware: Middleware = ({ getState, dispatch }) => (next) => (action) => {
  if (action.type === persistPaymentFlow.type) {
    const state = getState();
    const donation = getActiveDonation(state);
    const subscription = getActiveSubscription(state);
    const affiliate = getAffiliate(state);

    if (donation || subscription) {
      // Expire data in 30 minutes
      const expireDate = Date.now() + 30 * 60 * 1000;
      localStorage.setItem('pm', JSON.stringify({ donation, subscription, affiliate, expireDate }));
    }
  }

  if (action.type === initialPaymentFlow.type) {
    let data;
    if (isBrowser()) {
      const { expireDate, ...persistedData } = JSON.parse(localStorage.getItem('pm') || '{}');
      if (expireDate && Date.now() > expireDate) {
        localStorage.removeItem('pm');
      } else {
        data = persistedData;
      }
    }
    dispatch(actions.restoreState(data));
  }

  if (action.type === startPaymentFlow.type || action.type === completePaymentFlow.type) {
    localStorage.removeItem('pm');
  }

  return next(action);
};

export default persistMiddleware;
